import { useAuth } from './useAuth';

/**
 * Права текущего пользователя по ролям (та же матрица, что проверяет сервер):
 * - canOperate — создавать и проводить документы, выпуски, продажи, вести пересчёт (OPERATOR и выше);
 * - canManage — отменять проведённое, удалять, править справочники, утверждать инвентаризацию (MANAGER и выше);
 * - isAdmin — пользователи, настройки, резервные копии.
 * Скрытие кнопок — только удобство: окончательно права проверяет сервер.
 */
export const usePermissions = () => {
  const { state } = useAuth();
  const role = state.user?.role;

  const isAdmin = role === 'ADMIN';
  const canManage = isAdmin || role === 'MANAGER';
  const canOperate = canManage || role === 'OPERATOR';

  return { role, isAdmin, canManage, canOperate };
};
